export enum SupportedLanguage {
  Ru = 'ru',
  En = 'en',
  Ua = 'ua',
  Es = 'es',
  Default = 'en',
}
